import * as React from 'react';

export default function Loading(){
    return <>Loading...</>;
}